// extracted by mini-css-extract-plugin
export default {"container":"subscribe_container__RXbm+","all":"subscribe_all__VXOkY"};